import React from "react";
import cx from "classnames";
import {createUseStyles} from "react-jss";

const useStyles = createUseStyles({
    logo: {
        "&.size-small": {
            height: 20,
        },
        "&.size-medium": {
            height: 40,
        },
        "&.size-large": {
            height: 60,
        },
        "&.mode-light": {
            "& .label > path, & #v, & #m": {
                fill: "#000000",
            },
        },
        "&.mode-dark": {
            "& .label > path, & #v, & #m": {
                fill: "#ffffff",
            },
        },
        "&.mode-black": {
            "& > .icon > path": { stroke: "#000000" },
            "& .label > path, & #v, & #m": {
                fill: "#000000",
            },
        },
        "&.mode-white": {
            "& > .icon > path": { stroke: "#ffffff" },
            "& .label > path, & #v, & #m": {
                fill: "#ffffff",
            },
        },
    },
    v: {},
    m: {},
    corner: {
        fill: "none",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "4px",
    },
    corner1: { stroke: "#d8842f" },
    corner2: { stroke: "#e2903c" },
    corner3: { stroke: "#700b62" },
    corner4: { stroke: "#932484" },
    corner5: { stroke: "#1d9157" },
    corner6: { stroke: "#1e9e5e" },
    corner7: { stroke: "#346da2" },
    corner8: { stroke: "#619c58" },
    corner9: { stroke: "#70ac67" },
    corner10: { stroke: "#4485c1" },
    corner11: { stroke: "#c20012" },
    corner12: { stroke: "#b93363" },
    corner13: { stroke: "#a02753" },
    corner14: { stroke: "#cf0b1d" },
    corner15: { fill: "#0c0b0f" },
});

export const Logo = ({ className, size="medium", mode="light", showLabel=true }) => {
    const styles = useStyles();
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox={`0 0 ${showLabel ? 270.18 : 90.09} 90`}
            className={cx(
                styles.logo,
                className,
                `size-${size}`,
                `mode-${mode}`
            )}
        >
            <g className="icon">
                <path
                    className={cx(styles.corner, styles.corner1)}
                    d="M26.47 32.68l11.09 5.46a8 8 0 006.89.12l10.6-5.33"
                />
                <path
                    className={cx(styles.corner, styles.corner1)}
                    d="M55.34 32.77l-9.85 5A8 8 0 0041 45v9.79"
                />
                <path
                    d="M26.47 32.68s7.35 3.66 10 5A8.2 8.2 0 0141 45v9.79"
                    className={cx(styles.corner, styles.corner2)}
                />
                <path
                    className={cx(styles.corner, styles.corner3)}
                    d="M2.47 38L2.4 25.68a8 8 0 014.29-7.09l9.53-4.69"
                />
                <path
                    className={cx(styles.corner, styles.corner3)}
                    d="M17.21 28.1l-9.46-4.57a3 3 0 01-.12-5.33l8.66-4.2"
                />
                <path
                    d="M17.22 28.11l-9.1-4.37a4 4 0 00-5.72 3.61L2.46 38"
                    className={cx(styles.corner, styles.corner4)}
                />
                <path
                    className={cx(styles.corner, styles.corner5)}
                    d="M27.27 81l10.28 5.5a8 8 0 007.46 0l9.76-5.06"
                />
                <path
                    className={cx(styles.corner, styles.corner5)}
                    d="M41 71.74v10.5a3.71 3.71 0 005.34 3.44c4.12-2 8.33-4.32 8.33-4.32"
                />
                <path
                    d="M41 71.74v10.15a3.72 3.72 0 01-5.35 3.45c-4.16-2-8.44-4.33-8.44-4.33"
                    className={cx(styles.corner, styles.corner6)}
                />
                <path
                    className={cx(styles.corner, styles.corner7)}
                    d="M9.79 72.59a4.19 4.19 0 010-7.15"
                />
                <path
                    className={cx(styles.corner, styles.corner8)}
                    d="M79.47 51.94l-.19 11.29a4 4 0 01-5.89 3.2l-2.73-1.53M71.81 72.47a4.14 4.14 0 00-.29-7"
                />
                <path
                    d="M79.52 51.94v11.68a8 8 0 01-4.32 7.1L65 76"
                    className={cx(styles.corner, styles.corner9)}
                />
                <path
                    className={cx(styles.corner, styles.corner7)}
                    d="M2.51 51.87V62.8a4 4 0 005.77 3.39l2.63-1.3"
                />
                <path
                    d="M2.49 51.88v12.63a7.77 7.77 0 004.41 6.64l9.81 4.9"
                    className={cx(styles.corner, styles.corner10)}
                />
                <path
                    className={cx(styles.corner, styles.corner11)}
                    d="M79.31 38.05V25.87A8 8 0 0075 18.76l-9.47-4.88"
                />
                <path
                    className={cx(styles.corner, styles.corner12)}
                    d="M55.45 8.94l-10.81-5.6a8 8 0 00-7.35 0l-10.82 5.6"
                />
                <path
                    className={cx(styles.corner, styles.corner11)}
                    d="M64.81 28l8.64-4.32a4.11 4.11 0 015.8 3.75V38"
                />
                <path
                    className={cx(styles.corner, styles.corner12)}
                    d="M41 18.32V8.49a4 4 0 015.66-3.63l8.79 4"
                />
                <path
                    d="M41 18.32V8.49a4 4 0 00-5.7-3.63l-8.79 4"
                    className={cx(styles.corner, styles.corner13)}
                />
                <path
                    d="M65.13 27.88l8.72-4.42a2.88 2.88 0 00.15-5.21l-8.5-4.38"
                    className={cx(styles.corner, styles.corner14)}
                />
                <g>
                    <path
                        id="v"
                        className={cx(styles.corner, styles.corner15)}
                        d="M29.76 44.92l-3.91-1.87-4.94 15.89-5.24-20.75-4.02-1.92 7.16 27.19 4.14 2.07 6.81-20.61"
                    />
                    <path
                        id="m"
                        className={cx(styles.corner, styles.corner15)}
                        d="M70.8 35.45l-4.82 2.46-5.54 19.67-5.34-14.12-5.08 2.59-.13 23.71 3.64-1.85.1-17.13 5.25 14.06 2.78-1.41 5.45-19.32-.09 16.92 3.65-1.86.13-23.72"
                    />
                </g>
            </g>
            {showLabel && (
                <g className="label">
                    <path
                        className={cx(styles.corner, styles.corner15)}
                        d="M101.08 52.75h-3.36L92.17 36.2h3.24l4.06 12.63 4-12.63h3.08zM108.12 38.93v-3h3.17v3zm.1 13.82V40.61h3v12.14zM120.82 43.2c-2.08 0-3.17 1.47-3.17 3.43v6.12h-3V40.61h2.51l.26 1.82a3.53 3.53 0 013.47-2 5.62 5.62 0 01.92.07v2.8a5 5 0 00-.99-.1zM128.41 52.91c-2.49 0-3.71-1.4-3.71-3.73V43h-2.25v-2.4h2.25v-3.07l3-.73v3.81h3.1V43h-3.1v5.91c0 .93.43 1.33 1.37 1.33a14.05 14.05 0 001.92-.12v2.46a10.2 10.2 0 01-2.58.33zM141 52.75l-.21-1.59a3.8 3.8 0 01-3.52 1.89 4 4 0 01-4.27-4.34v-8.1h3v7.45c0 1.42.56 2.31 2.12 2.31a2.07 2.07 0 001.52-.61 3.69 3.69 0 00.9-2.73v-6.42h2.95v12.14zM157.25 47.59H149a3.2 3.2 0 00.9 2.38 2.57 2.57 0 001.82.75 2.26 2.26 0 001.79-.59 2.09 2.09 0 00.59-1h2.9a4.81 4.81 0 01-1 2.24 5.3 5.3 0 01-4.13 1.7 5.4 5.4 0 01-3.88-1.49A6.54 6.54 0 01146 46.7a6.77 6.77 0 011.77-4.85 5.34 5.34 0 013.92-1.54 5.23 5.23 0 014.5 2.24 6.78 6.78 0 011.06 4.22v.82zm-3.69-4.25a2.49 2.49 0 00-1.87-.7 2.54 2.54 0 00-2.06.93 3 3 0 00-.63 1.9h5.31a3.14 3.14 0 00-.75-2.13zM163.06 52.89c-2 0-3.35-1-3.35-3.27V35.87h3v13.26c0 .7.17 1.17 1.19 1.17h.49v2.45a5.26 5.26 0 01-1.33.14zM171.08 52.91c-2.49 0-3.72-1.4-3.72-3.73V43h-2.24v-2.4h2.24v-3.07l3-.73v3.81h3.1V43h-3.1v5.91c0 .93.42 1.33 1.37 1.33a13.83 13.83 0 001.91-.12v2.46a10.06 10.06 0 01-2.56.33zM189.84 52.75V40.94l-4.35 11.58h-2.24l-4.33-11.72v12H176V36.2h4.11l4.37 11.8 4.42-11.8h3.9v16.55zM204.15 52.75l-.22-1.59a3.8 3.8 0 01-3.52 1.89 4 4 0 01-4.25-4.34v-8.1h3v7.45c0 1.42.57 2.31 2.13 2.31a2 2 0 001.51-.61 3.69 3.69 0 00.9-2.73v-6.42h2.95v12.14zM218.52 51.65a5.91 5.91 0 01-4.21 1.4 5.64 5.64 0 01-4-1.4 4 4 0 01-1.3-2.82h2.77a1.93 1.93 0 00.66 1.42 2.77 2.77 0 001.86.54c1 0 2.51-.21 2.51-1.54a1.29 1.29 0 00-1.2-1.25c-1.09-.16-2.32-.23-3.4-.46a3.39 3.39 0 01-2.82-3.25 3.44 3.44 0 011.26-2.73 5.68 5.68 0 013.73-1.21 5.3 5.3 0 013.85 1.42 3.72 3.72 0 011.09 2.5h-2.81a1.65 1.65 0 00-.5-1.15 2.37 2.37 0 00-1.6-.56 3 3 0 00-1.28.19 1.39 1.39 0 00-.95 1.28c0 .87.76 1.13 1.42 1.22 1.11.14 1.42.16 2.63.35 1.93.3 3.35 1.52 3.35 3.43a3.57 3.57 0 01-1.06 2.62zM232.47 47.59h-8.23a3.2 3.2 0 00.9 2.38 2.59 2.59 0 001.82.75 2.26 2.26 0 001.79-.59 2.18 2.18 0 00.6-1h2.83a4.71 4.71 0 01-1 2.24 5.3 5.3 0 01-4.13 1.7 5.4 5.4 0 01-3.88-1.49 6.54 6.54 0 01-1.89-4.86 6.77 6.77 0 011.72-4.87 5.34 5.34 0 013.92-1.54 5.23 5.23 0 014.5 2.24 6.78 6.78 0 011.06 4.22s-.01.56-.01.82zm-3.69-4.25a2.78 2.78 0 00-3.92.23 2.92 2.92 0 00-.64 1.9h5.32a3.19 3.19 0 00-.76-2.13zM242.8 52.75l-.22-1.59a3.8 3.8 0 01-3.52 1.89 4 4 0 01-4.25-4.34v-8.1h2.95v7.45c0 1.42.57 2.31 2.13 2.31a2 2 0 001.51-.61 3.69 3.69 0 00.9-2.73v-6.42h2.95v12.14zM263.17 52.75v-7.54c0-1.5-.4-2.36-1.89-2.36-1.68 0-2.41 1.75-2.41 3.27v6.63h-2.93v-7.54c0-1.5-.4-2.36-1.89-2.36-1.68 0-2.44 1.75-2.44 3.27v6.63h-2.93V40.61h2.46l.24 1.61a3.94 3.94 0 013.5-1.91 3.65 3.65 0 013.52 2 4.09 4.09 0 013.71-2c2.62 0 4 1.72 4 4.25v8.19z"
                    />
                </g>
            )}
        </svg>
    );
};
